<template>
  <div class="common-page-main main-page">
    <div class="field-box scroll-cotar">
      <div class="page-top-bar cfa">
        <div class="headline lfp">
          <span>Configuration management</span>
        </div>
      </div>
      <div class="table-wrap">
        <EnquiryOnlineConfigForm @updateSuccess="handleUpdate" ref="popForm"></EnquiryOnlineConfigForm>
      </div>
    </div>
  </div>
</template>

<script>
// import $ from 'jquery'
// import mixin from '@/components/common/mixin'
import tools from '@/components/common/tools'
import EnquiryOnlineConfigForm from '@/components/product/EnquiryOnlineConfigForm'

// 请求相关操作
let page = {
  methods: {
    getDataAjax() {
      tools.commonAjax.call(this, true, '/Ajax/GetConfigInfoInCommon', {
      }).then((res) => {
        this.$refs.popForm.setValue(res.data)
      })
    }
  }
}

export default {
  name: 'EnquiryOnlineConfigManagement',
  mixins: [page],
  components: {
    EnquiryOnlineConfigForm
  },
  created() {
    this.getDataAjax()
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    // 修改操作
    handleUpdate() {
      // 刷新表格数据
      this.getDataAjax()
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/lib-config";
</style>



// WEBPACK FOOTER //
// EnquiryOnlineConfigManagement.vue?3388e04f